import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onRouteUpdate = () => {
  if (typeof document !== "undefined") {
    const elements = document.querySelectorAll(".fadeInUp, .fadeIn")

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on")
          }
        })
      },
      { threshold: 0.1 }
    )

    elements.forEach(el => observer.observe(el))

    // カウントアップ
    const counterElements = document.querySelectorAll(".scr-counter")

    const counterObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".counter-num").forEach(el => {
              const target = parseInt(el.dataset.target)
              let current = 0
              const step = target / 60
              const timer = setInterval(() => {
                current += step
                if (current >= target) {
                  current = target
                  clearInterval(timer)
                }
                el.textContent = Math.floor(current)
              }, 16)
            })
            counterObserver.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.3 }
    )

    counterElements.forEach(el => counterObserver.observe(el))

    return () => {
      elements.forEach(el => observer.unobserve(el))
      counterElements.forEach(el => counterObserver.unobserve(el))
    }
  }
}

export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js")
  }
}
